export default __webpack_public_path__ + "static/car-559f6cfbc194589b21bd54f5ffa2866e.png";